import React, { useCallback, useState, useEffect } from 'react';
import '../styles/HomeArticles.css';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import { IoIosArrowForward, IoMdArrowDropright } from 'react-icons/io';
import { Spinner } from 'react-bootstrap';
import { BiCalendar, BiUser } from 'react-icons/bi';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';

// Constants

function HomeArticles() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [articles, setArticles] = useState([]);
    const articlePath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.ARTICLE_PATH });
    const articleBasePath = articlePath[0].pathBeforeParams;
    const fetchRecentArticles = useCallback(async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams();
            params.append('page', 0);
            params.append('limit', 10);
            params.append('sortBy', 'CREATED');
            params.append('order', 'DESC');
            
            const response = await fetch(new URL(`/api/articles?${params.toString()}`, process.env.APP_URL));
            const data = await response.json();
            if (data.articles) {
                setArticles(data.articles);
            }
        } catch (e) {
            console.info('Failed to fetch recent articles:', e.message);
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchRecentArticles();
    }, [fetchRecentArticles]);

    if (!loading && !articles?.length) {
        return null;
    }
    return (
        <div
            className={'mt-4'}>
            <div>
                <div
                    className={'d-flex justify-content-between'}>
                    <h4>From Our Blog</h4>
                    <button
                        onClick={()=>{
                            navigate('/blog');
                        }}
                        className={'unstyled-button home-articles--heading-show-more-btn'}>
                        <IoIosArrowForward
                            size={24} />
                    </button>
                </div>
                <div
                    className={'home-articles--heading-bottom-line mt-2'}>
                </div>
            </div>
            <div
                className={'d-flex justify-content-center align-items-center mt-3'}>
                {loading && <Spinner />}
            </div>
            <div
                className={'home-articles--container d-flex gap-2 justify-content-center mt-2'}>
                {articles.map((article) => {
                    return <div
                        style={{
                            flexGrow: '1',
                        }}
                        key={article.id}>
                        <div
                            className={'home-articles--card w-100'}>
                            <a
                                href={`${articleBasePath}/${article.handle}`}
                                className={'custom-link w-100'}>
                                <div
                                    className={'w-100'}
                                    style={{
                                        height: '300px',
                                    }}>
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                        }}
                                        src={article.imageUrl}
                                        alt={article.title}
                                        className={'home-articles--image'}
                                    />
                                </div>
                            </a>
                            <div
                                className={'w-100 mt-2'}>
                                <h5
                                    className={'text-muted text-start'}>{article.title}</h5>
                                <div
                                    className={'d-flex gap-2 text-muted text-start'}>
                                    {article.author && <span
                                        style={{
                                            whiteSpace: 'nowrap',
                                        }}><BiUser
                                            size={16} /> {article.author}</span>}
                                    <span
                                        style={{
                                            whiteSpace: 'nowrap',
                                        }}><BiCalendar
                                            size={16} /> {DateTime.fromISO(article.createdAt).toFormat('yyyy LLL dd')}</span>
                                </div>
                            </div>
                            <div
                                className={'home-articles--card-separator'}></div>
                            <div
                                className={'home-articles--card-footer'}>
                                <a
                                    href={`${articleBasePath}/${article.handle}`}
                                    className={'custom-link'}>
                                    <IoMdArrowDropright
                                        size={24} /> Read More
                                </a>
                            </div>
                        </div>
                    </div>;
                })}
            </div>
        </div>
    );
}

export default HomeArticles;